import { useState } from "react";
import { UserPlus, KeyRound, Copy } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";

const cls = "px-2 py-1.5 text-xs border border-slate-300 rounded-md bg-white outline-none focus:border-orange-500 min-w-0";

// Şube kartı › İşi Yapan Taşeron: listeden ayrılmadan taşeron kullanıcısı aç (cari seç + ad + e-posta) → hesap açılır, geçici şifre e-postalanır, yeni kullanıcı listede seçili gelir
export default function QuickSubUserCreate({ subOpts, defaultCariId = "", onCreated }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ cari_id: defaultCariId, name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const pickCari = (id) => setF((p) => ({ ...p, cari_id: id, name: p.name || subOpts.find((o) => o.value === id)?.label || "" }));
  const save = async () => {
    if (!f.cari_id) { toast.error("Taşeron carisi seçin"); return; }
    if (!f.name.trim() || !f.email.trim()) { toast.error("Ad Soyad ve e-posta zorunlu"); return; }
    setBusy(true);
    try {
      const { data } = await http.post(`/subcontractors/${f.cari_id}/create-user`, { name: f.name, email: f.email, phone: f.phone });
      setDone(data);
      toast.success(data.mail_status === "sent" ? "Taşeron kullanıcısı açıldı — şifre e-postalandı, listede seçildi" : "Kullanıcı açıldı — e-posta gönderilemedi, şifreyi elle iletin");
      await onCreated?.(data.user_id, f.cari_id);
      setF({ cari_id: f.cari_id, name: "", email: "", phone: "" });
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-1" data-testid="quick-sub-user">
      {done && (
        <div className="text-[11px] border border-emerald-300 bg-emerald-50 rounded-md px-2 py-1 flex flex-wrap items-center gap-x-2" data-testid="quick-sub-user-done">
          <KeyRound className="w-3 h-3 text-emerald-700" /><b className="text-emerald-800">{done.email}</b> açıldı · geçici şifre <b className="font-mono" data-testid="quick-sub-user-temp-password">{done.temp_password}</b>
          <button type="button" onClick={() => { navigator.clipboard?.writeText(done.temp_password); toast.success("Kopyalandı"); }} className="p-0.5 text-emerald-700 hover:text-emerald-900" title="Kopyala"><Copy className="w-3 h-3" /></button>
          <button type="button" onClick={() => setDone(null)} className="ml-auto text-slate-500 hover:text-slate-800">kapat</button>
        </div>
      )}
      {!open
        ? <button type="button" onClick={() => setOpen(true)} data-testid="quick-sub-user-open" className="inline-flex items-center gap-1 text-[11px] font-bold text-orange-700 hover:text-orange-900"><UserPlus className="w-3.5 h-3.5" /> Yeni taşeron kullanıcısı oluştur</button>
        : (
          <div className="border border-orange-300 bg-orange-50 rounded-md p-2 grid grid-cols-2 gap-1.5" data-testid="quick-sub-user-form">
            <select value={f.cari_id} onChange={(e) => pickCari(e.target.value)} data-testid="quick-sub-user-cari" className={`${cls} col-span-2`}>
              <option value="">— Taşeron carisi —</option>
              {subOpts.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
            <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Ad Soyad" data-testid="quick-sub-user-name" className={cls} />
            <input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="E-posta" data-testid="quick-sub-user-email" className={cls} />
            <input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Telefon (isteğe bağlı)" data-testid="quick-sub-user-phone" className={`${cls} col-span-2`} />
            <div className="col-span-2 flex items-center gap-2">
              <button type="button" disabled={busy} onClick={save} data-testid="quick-sub-user-save" className="px-3 py-1.5 rounded-md bg-orange-600 text-white text-xs font-bold hover:bg-orange-700 disabled:opacity-50">{busy ? "Oluşturuluyor…" : "Hesap Aç ve Seç"}</button>
              <button type="button" onClick={() => setOpen(false)} data-testid="quick-sub-user-cancel" className="px-2 py-1.5 text-xs text-slate-600">İptal</button>
              <span className="text-[10px] text-slate-500">Geçici şifre e-postalanır; ilk girişte değiştirilir.</span>
            </div>
          </div>
        )}
    </div>
  );
}
